import { Award, Clock, ShieldCheck, Star } from "lucide-react";

const AdvantageItem = ({ Icon, title, desc }) => (
  <div className="flex items-center gap-3">
    <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
      <Icon className="h-6 w-6" />
    </div>
    <div>
      <p className="font-semibold text-sm">{title}</p>
      <p className="text-white/70 text-xs">{desc}</p>
    </div>
  </div>
);

export const AdvantagesBar = () => (
  <section className="py-6 bg-slate-800 text-white">
    <div className="container-custom">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <AdvantageItem Icon={Award} title="Techniciens Certifiés" desc="Apple & Multi-marques" />
        <AdvantageItem Icon={Clock} title="Réparation Express" desc="Dès 30 minutes" />
        <AdvantageItem Icon={ShieldCheck} title="Garantie 6-12 mois" desc="Pièces & main d'œuvre" />
        <AdvantageItem Icon={Star} title="4.6/5 Google" desc="212+ avis clients" />
      </div>
    </div>
  </section>
);
